//引入常量对象
import CONSTANCE from "@/static/js/constance"

export default function() {
  return {
    //配置标题
    title: {
      //是否显示标题
      show: true,
      //标题内容
      text: '',
      //标题文字配置
      textStyle: {
        color: CONSTANCE.GRAPH_FONT_COLOR,
        fontStyle: 'normal',
        fontWeight: 'bold',
        fontFamily: CONSTANCE.FONT_FAMILY,
      },
      //设置标题距离左边的距离('left'、'10%', 10)
      left: 'left',
    },
    tooltip: {
      trigger: 'item'
    },
    //配置图例
    legend: {
      //是否显示图例
      show: true,
      //设置图例文字
      textStyle: {
        color: CONSTANCE.GRAPH_FONT_COLOR,
        fontStyle: 'normal',
        fontFamily: CONSTANCE.FONT_FAMILY,
        fontSize: CONSTANCE.GRAPH_LEGEND_FONT_SIZE
      },
      //设置图例列表距离左边的距离('left'、'10%', 10)
      left: 'center',
      //距离顶部的距离（'bottom', '10%', 10）
      top: 'bottom',
      //图例列表的布局朝向（horizontal、vertical）
      orient: 'horizontal'
    },
    series: [
      {
        // name: 'Access From',
        type: 'pie',
        radius: ['0', '70%'],
        avoidLabelOverlap: false,
        itemStyle: {
          borderRadius: 5,
          borderColor: 'transparent',
          borderWidth: 5
        },
        label: {
          show: false,
          color: CONSTANCE.GRAPH_FONT_COLOR,
          fontFamily: CONSTANCE.FONT_FAMILY,
          position: 'center'
        },
        labelLine: {
          show: true
        },
        emphasis: {
          label: {
            show: true,
            fontSize: '16',
            fontWeight: 'bold'
          }
        }
      }
    ]
  }
}